<template>
  <form class="search-bar" @submit.prevent="searchItem()">
    <input type="text" class="search-input" v-model="searchInput" placeholder="Buscar clase o categoría" />
    <button class="search-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
        <mask id="mask0_1448_2585" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="35"
          height="36">
          <rect y="0.500122" width="35" height="35" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1448_2585)">
          <path
            d="M28.8488 30.872L19.7705 21.7934C19.0478 22.3901 18.2166 22.8571 17.2771 23.1944C16.3376 23.5316 15.3657 23.7003 14.3613 23.7003C11.8909 23.7003 9.80007 22.845 8.08893 21.1343C6.37779 19.4237 5.52222 17.3334 5.52222 14.8634C5.52222 12.3937 6.37755 10.3027 8.0882 8.5904C9.79886 6.87832 11.8892 6.02228 14.3592 6.02228C16.8289 6.02228 18.92 6.87783 20.6323 8.58895C22.3444 10.3001 23.2005 12.3908 23.2005 14.8613C23.2005 15.8935 23.0273 16.8794 22.6808 17.8189C22.3342 18.7584 21.8718 19.5756 21.2936 20.2703L30.3719 29.3485L28.8488 30.872ZM14.3613 21.5325C16.2238 21.5325 17.8012 20.8862 19.0937 19.5935C20.3863 18.3011 21.0327 16.7237 21.0327 14.8613C21.0327 12.9989 20.3863 11.4215 19.0937 10.129C17.8012 8.83635 16.2238 8.19002 14.3613 8.19002C12.4989 8.19002 10.9215 8.83635 9.62902 10.129C8.33633 11.4215 7.68999 12.9989 7.68999 14.8613C7.68999 16.7237 8.33633 18.3011 9.62902 19.5935C10.9215 20.8862 12.4989 21.5325 14.3613 21.5325Z"
            fill="url(#paint0_linear_1448_2585)" />
        </g>
        <defs>
          <linearGradient id="paint0_linear_1448_2585" x1="5.52222" y1="18.4471" x2="30.3719" y2="18.4471"
            gradientUnits="userSpaceOnUse">
            <stop offset="0.23516" stop-color="#4536EF" />
            <stop offset="0.913242" stop-color="#FF00B8" />
          </linearGradient>
        </defs>
      </svg>
    </button>
  </form>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchInput: '',
    };
  },
  methods: {
    searchItem() {
      const query = this.normalizeText(this.searchInput);
      if (query === '') {
        this.removeSearch();
      }
      if (query) {
        const currentQuery = this.$route.query.search;

        // Verifica si la búsqueda actual es la misma que la nueva búsqueda
        if (query !== currentQuery) {
          this.$router.push({ path: '/web-app', query: { a: this.$route.query.a, search: query } });
        } else {
          console.log('Ya estás viendo los resultados de esta búsqueda');
        }
      } else {
        console.log('El campo de búsqueda está vacío');
      }
    },
    normalizeText(texto) {
      const normal = texto
        .toLowerCase()
        .replace(/\s+/g, '-');

      return normal;
    },
    deNormalizeText(texto) {
      if (texto) {
        const original = texto.replace(/-/g, ' ')

        return original;
      }
    },
    
    removeSearch() {
      this.$router.push({ path: '/web-app', query: { a: this.$route.query.a } });
    },
  },
};  
</script>

<style scoped>
.search-bar {
  display: flex;
  width: 23.9583vw;
  height: 3.4722vw;
  padding: 0.2778vw 1.0417vw;
  justify-content: space-between;
  align-items: center;
  border-radius: 20.8333vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background-color: white;
}

.search-input {
  border: none;
  outline: none;
  width: 100%;
  font-family: Inter, sans-serif;
  font-size: 1.0417vw;
  font-weight: 300;
  color: var(--Text, #464d5b);
}

.search-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.4306vw;
  height: 2.4306vw;
  flex-shrink: 0;
}

@media (max-width: 530px) {
  .search-bar {
    width: 100%;
    display: flex;
    height: 12.5vw;
    padding: 4.25vw 3.75vw;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 300px;
    border: 1px solid var(--background-gray, #E3E3E9);
  }

  .search-input {
    color: var(--Text, #464D5B);
    font-family: Inter, sans-serif;
    font-size: 3.75vw;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
  }

  .search-icon {
    width: 8.75vw;
    height: 8.75vw;
  }
}
</style>
